module.exports = __webpack_public_path__ + "img/ch2.ed0fb592.jpg";